document.addEventListener('DOMContentLoaded', function() {
  var currentUrl = window.location.pathname;
  if (currentUrl.includes('/collections/') && !currentUrl.includes('/products/')) {
    var breadcrumbSection = document.querySelector('.ed_breadcrumbs-section.page-width');

    if (breadcrumbSection) {
      breadcrumbSection.style.position = 'absolute';
      breadcrumbSection.style.zIndex = '27';
    }
  }

  document.querySelectorAll('.product-slider').forEach(function(slider) {
      var sliderWrapper = slider.querySelector('.slider-wrapper');
      var sliderItems = slider.querySelectorAll('.grid__item');
      var prevButton = slider.querySelector('.slider-prev');
      var nextButton = slider.querySelector('.slider-next');
  
      var currentIndex = 0;
      var totalItems = sliderItems.length;
      var itemWidth = sliderItems[0].offsetWidth;
  
      function showSlide(index) {
          if (window.innerWidth > 768) return;
          var offset = -index * itemWidth;
          sliderWrapper.style.transform = 'translateX(' + offset + 'px)';
          updateButtons();
      }
  
      function updateButtons() {
          prevButton.style.display = currentIndex > 0 ? 'block' : 'none';
          nextButton.style.display = currentIndex < totalItems - 1 ? 'block' : 'none';
      }
  
      prevButton.addEventListener('click', function() {
          if (currentIndex > 0) {
              currentIndex--;
              showSlide(currentIndex);
          }
      });
  
      nextButton.addEventListener('click', function() {
          if (currentIndex < totalItems - 1) {
              currentIndex++;
              showSlide(currentIndex);
          }
      });
  
      showSlide(currentIndex);
  });

  const desktopContainer = document.getElementById('desktop-language-switcher-container');
  const mobileContainer = document.getElementById('mobile-language-switcher-container');

  function moveLanguageSwitcher() {
    const languageSwitcher = document.getElementById('language-switcher');
    if (languageSwitcher) {
      const isMobile = window.innerWidth <= 768;
      if (isMobile && !mobileContainer.contains(languageSwitcher)) {
        mobileContainer.appendChild(languageSwitcher);
      } else if (!isMobile && !desktopContainer.contains(languageSwitcher)) {
        desktopContainer.appendChild(languageSwitcher);
      }
    }
  }

  // Verifica periódicamente si el `<div id="language-switcher">` ya está disponible
  const observer = new MutationObserver(() => {
    moveLanguageSwitcher();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Reajustar al redimensionar la ventana
  window.addEventListener('resize', moveLanguageSwitcher);

});
